// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__3zYfT","dragIcon":"SortableItem_dragIcon__5JSqk","disabled":"SortableItem_disabled__1JAYY"};